var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6106_119337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 15.1693C4.31767 15.1693 1.33301 12.1846 1.33301 8.5026C1.33301 4.8206 4.31767 1.83594 7.99967 1.83594C11.6817 1.83594 14.6663 4.8206 14.6663 8.5026C14.6663 12.1846 11.6817 15.1693 7.99967 15.1693ZM7.99967 13.8359C9.41416 13.8359 10.7707 13.274 11.7709 12.2738C12.7711 11.2736 13.333 9.91709 13.333 8.5026C13.333 7.08812 12.7711 5.73156 11.7709 4.73137C10.7707 3.73117 9.41416 3.16927 7.99967 3.16927C6.58519 3.16927 5.22863 3.73117 4.22844 4.73137C3.22824 5.73156 2.66634 7.08812 2.66634 8.5026C2.66634 9.91709 3.22824 11.2736 4.22844 12.2738C5.22863 13.274 6.58519 13.8359 7.99967 13.8359ZM7.33301 5.16927H8.66634V6.5026H7.33301V5.16927ZM7.33301 7.83594H8.66634V11.8359H7.33301V7.83594Z",
    fill: "#22428F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6106_119337"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoBlue);
export default __webpack_public_path__ + "static/media/info-blue.9ecf7c137a10febf6ba2fe1f9b89ce02.svg";
export { ForwardRef as ReactComponent };